import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Features } from "@/components/landing/Features";
import { About } from "@/components/landing/About";
import { Showcase } from "@/components/landing/Showcase";
import { Devices } from "@/components/landing/Devices";
import { TrustStrip } from "@/components/landing/TrustStrip";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials } from "@/components/landing/Testimonials";
import { Faq } from "@/components/landing/Faq";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { FloatingButtons } from "@/components/landing/FloatingButtons";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

export default function Landing() {
  useSmoothScroll();
  return (
    <div className="bg-bp-bg text-white min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Features />
        <About />
        <Showcase />
        <Devices />
        <TrustStrip />
        <Pricing />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
